import request from "@/services/orderKitRequest";

export function generateOrderIdApi() {
  return request({
    url: "/generateOrderId/kitorder",
    method: "get",
  });
}